import { jsx } from "react/jsx-runtime";
const FIGMA_DOT_STROKE = "#B8B8B8";
const FIGMA_DOT_STROKE_WIDTH = 2;
const FIGMA_DOT_DASH = "1 5";
function PrintDotLine() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "print-dot-line",
      width: "100%",
      height: "4",
      overflow: "visible",
      style: { display: "block" },
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "line",
        {
          x1: "1",
          y1: "2",
          x2: "100%",
          y2: "2",
          stroke: FIGMA_DOT_STROKE,
          strokeWidth: FIGMA_DOT_STROKE_WIDTH,
          strokeLinecap: "round",
          strokeDasharray: FIGMA_DOT_DASH
        }
      )
    }
  );
}
export {
  PrintDotLine
};
//# sourceMappingURL=PrintDotLine.js.map
